import { render, staticRenderFns } from "./BarManagement.vue?vue&type=template&id=f9f74d46&scoped=true"
import script from "./BarManagement.vue?vue&type=script&lang=js"
export * from "./BarManagement.vue?vue&type=script&lang=js"
import style0 from "./BarManagement.vue?vue&type=style&index=0&id=f9f74d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f74d46",
  null
  
)

export default component.exports